import React from 'react';
import SectionHeader from 'components/SectionHeader';
import INVESTMENT_ASSET, {
  CRYPTO, LISTED_COMPANY, OTHER, REAL_ESTATE,
} from 'constants/investmentAsset';
import { useSelector } from 'react-redux';
import { Breadcrumb } from 'xland-ui';
import { useLocation } from 'react-router-dom';
import AdminStartups from './tabs/Startups';
import AdminFunds from './tabs/Funds';
import AdminInvestmentAsset from './components';

function InvestmentAssets() {
  const literals = useSelector((state) => state.i18n.literals.investmentAssets);
  const { hash } = useLocation();
  const tabs = INVESTMENT_ASSET.map(asset => ({ key: asset, name: literals?.[asset] }));

  return (
    <>
      <Breadcrumb routes={[{ name: literals.title }]} />
      <SectionHeader tabs={tabs} hash defaultTab={hash.slice(1) || 'company'}>
        {(tab) => (
          <>
            {tab === 'company' && <AdminStartups />}
            {tab === 'fund' && <AdminFunds />}
            {tab === 'listedCompany' && <AdminInvestmentAsset type={LISTED_COMPANY} />}
            {tab === 'realEstate' && <AdminInvestmentAsset type={REAL_ESTATE} />}
            {tab === 'crypto' && <AdminInvestmentAsset type={CRYPTO} />}
            {tab === 'other' && <AdminInvestmentAsset type={OTHER} />}
          </>
        )}
      </SectionHeader>
    </>
  );
}

export default InvestmentAssets;
